/* eslint-disable react/react-in-jsx-scope */

import FormSelectInput from '../../../../components/forms/elements/FormSelectInput'

interface EventProps {
  id: string
  name: string
  priority: number
}

const DownloadParticipantFormContent = ({ formDisabled, events }) => [
  {
    id: 'download-participant-form-details',
    name: 'Events',
    inputs: [
      {
        id: 'eventId',
        size: 12,
        field: (
          <FormSelectInput
            name="eventId"
            label="Event"
            autoComplete="new-eventId"
            disabled={formDisabled}
            placeholder="Select Event"
            options={events
              .sort((a: EventProps, b: EventProps) => {
                if (!!a.priority && !b.priority) return -1
                if (!!b.priority && !a.priority) return 1
                return a.priority - b.priority
              })
              .map((event: EventProps) => ({
                value: event.id,
                text: event.name,
              }))}
            required
          />
        ),
      },
    ],
  },
]
export default DownloadParticipantFormContent
